module.exports = __webpack_public_path__ + "static/media/bushu-02.fb149baa.png";